import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { IDokumentItemViewModel, IDokumentViewModel } from './dokument.model';
import { SpinnerService } from '@services/spinner.service';
import { ChunkedUploadService, UploadHandle } from '@services/chunked-upload.service';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import Guid from 'devextreme/core/guid';
import { DxFileUploaderComponent } from 'devextreme-angular/ui/file-uploader';
import notify from 'devextreme/ui/notify';
import { ModalService } from 'ModalService';
import { EntityArt } from '@helper/enums/entityArt.enum';

@Component({
  selector: 'cz-dokumente',
  templateUrl: './dokumente.component.html',
  styleUrls: ['./dokumente.component.css'],
  standalone: false,
})
export class DokumenteComponent implements OnInit {
  @ViewChild('formUpload', { static: false }) formUpload: DxFormComponent;
  @ViewChild('fileUploader', { static: false }) fileUploader: DxFileUploaderComponent;

  allowedFileExtensions: string[] = ['.rtf', '.txt', '.docx', '.jpg', '.jpeg', '.pdf', '.xlsx', '.msg'];
  uploadFiles: File[];

  uploadPopupVisible: boolean = false;
  editBezPopupVisible: boolean = false;
  mappeBezPopupVisible: boolean = false;
  uploadWaitPopupVisible: boolean = false;

  selectedDokument: IDokumentItemViewModel;
  selectedMappe: IDokumentViewModel;
  uploadContext: any;

  toUpload: number = 0;
  isUploaded: number = 0;
  isUploadCanceled: boolean = false;
  uploadFileName: string = '';
  private currentUploadHandle: UploadHandle | null = null;

  fileNameModelData = {
    fileBez: '',
  };

  showUploadModal: boolean = false;
  loading = false;
  private _ownerId: number;
  von: Date;
  bis: Date;

  @Input() selectedFilterGroups: EntityArt[] = [];
  @Input() filterGroups: EntityArt[];
  filterGroupsFormated: any[] = [];

  @Input() entityArt: EntityArt;
  @Input() disabled: boolean = false;

  @Input()
  get ownerId(): number {
    return this._ownerId;
  }
  set ownerId(value: number) {
    this._ownerId = value;
  }

  dataSource: IDokumentViewModel[];

  constructor(
    private spinnerService: SpinnerService,
    private ajaxService: AjaxService,
    private modalService: ModalService,
    private chunkedUploadService: ChunkedUploadService
  ) {
    this.clear = this.clear.bind(this);
    this.onPopupClose = this.onPopupClose.bind(this);
    this.onPopupCloseOk = this.onPopupCloseOk.bind(this);
  }

  ngOnInit(): void {
    if (this.filterGroups && this.filterGroups.length > 0) {
      for (let i = 0; i < this.filterGroups.length; i++) {
        const e = EntityArt.keys()[this.filterGroups[i]];
        const v = EntityArt.shortKey(this.filterGroups[i]);
        this.filterGroupsFormated.push({ id: e.id, name: v, org: this.filterGroups[i] });
      }
      if (!this.selectedFilterGroups || this.selectedFilterGroups.length < 1) {
        this.selectedFilterGroups = this.filterGroups;
      }
    }
    this.loadDocuments();
  }

  loadDocuments() {
    this.startLoading();
    const _toSend: any = { entityArt: this.entityArt, ownerId: this.ownerId, filterGroups: this.selectedFilterGroups, von: this.von, bis: this.bis };
    // console.debug('loadDocuments', _toSend);
    this.ajaxService.post<IDokumentViewModel[]>('api/Dokument/Get', _toSend).subscribe((response) => {
      this.dataSource = response;
      this.stopLoading();
    });
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;
    const searchPanel = toolbarItems.filter((item) => item.name === 'searchPanel');

    if (searchPanel && searchPanel[0]) {
      searchPanel[0].location = 'before';
    }

    if (this.filterGroups && this.filterGroups.length > 0) {
      e.toolbarOptions.items.push({
        location: 'before',
        template: 'searchBarTemplate1',
      });
    }

    e.toolbarOptions.items.push({
      location: 'before',
      template: 'searchBarTemplate2',
    });

    e.toolbarOptions.items.push({
      location: 'before',
      template: 'searchBarTemplate3',
    });
  }

  docType_customizeText(cellInfo) {
    if (cellInfo.target !== 'row' || cellInfo.value === undefined || cellInfo.value === null) return '';
    const v = cellInfo.value as EntityArt;
    return EntityArt.shortKey(v);
  }

  changeValue(event) {
    this.loadDocuments();
  }

  onUploadCancel(e) {
    this.isUploadCanceled = true;
    if (this.currentUploadHandle) {
      this.currentUploadHandle.cancel();
      this.currentUploadHandle = null;
    }
  }

  public upload() {
    let isValid = true;
    const errorMsgs: string[] = [];

    for (let index = 0; index < this.uploadFiles.length; index++) {
      const file = this.uploadFiles[index];
      const ext = file.name.split('.').pop();
      if (!this.allowedFileExtensions.find((x) => x.endsWith(ext))) {
        errorMsgs.push("Dateitype wird nicht akzeptiert! '" + file.name + "'");
        isValid = false;
      }
    }
    if (!isValid) {
      notify(
        {
          contentTemplate: () => {
            let html = '';
            for (let index = 0; index < errorMsgs.length; index++) {
              const errorMsg = errorMsgs[index];
              html += errorMsg + '<br>';
            }

            return $('<div class="dx-toast-message" role="alert"></div>').html(html);
          },
          width: 600,
        },
        'error',
        3000
      );
      return;
    }

    const validationResult = this.formUpload.instance.validate();
    if (validationResult.isValid && this.uploadFiles != null) {
      this.isUploadCanceled = false;
      this.isUploaded = 0;
      this.toUpload = this.uploadFiles.length;
      this.showUploadModal = false;
      this.uploadWaitPopupVisible = true;

      const _obj = {
        ownerId: this.ownerId,
        entityArt: this.entityArt,
        bezeichnung: this.fileNameModelData.fileBez,
        docHash: new Guid().toString(),
      };

      this._upload(_obj, this.uploadFiles);
    }
  }

  private async _upload(context: any, files: File[]) {
    if (this.isUploaded === this.toUpload || this.isUploadCanceled === true) {
      this.clear();
      this.changeValue(null);
      return;
    }

    const file = files[this.isUploaded];
    this.uploadFileName = file.name;

    const lastDate = new Date(file.lastModified);
    lastDate.setHours(lastDate.getHours() + 1);
    context.lastModifiedDate = lastDate;

    try {
      this.currentUploadHandle = this.chunkedUploadService.uploadFile(file, context);
      await this.currentUploadHandle.promise;
      this.currentUploadHandle = null;
      this.isUploaded++;
      await this._upload(context, files);
    } catch (err) {
      if (this.currentUploadHandle) {
        this.currentUploadHandle.cancel();
        this.currentUploadHandle = null;
      }
      if (this.isUploadCanceled) {
        this.clear();
        return;
      }
      this.stopLoading();
      throw err;
    }
  }

  onAddFileToExist(event) {
    this.uploadContext = {
      ...event,
      ownerId: this.ownerId,
      entityArt: this.entityArt,
    };
    this.uploadPopupVisible = true;
  }

  addFile(event) {
    if (event && event.value && event.value.length > 0) {
      this.uploadFiles = event.value;
      this.showUploadModal = true;
    }
  }

  refreshDocuments(e) {
    this.loadDocuments();
  }

  onEditFile(data: IDokumentItemViewModel) {
    this.selectedDokument = data;
    this.editBezPopupVisible = true;
  }

  onEditMappe(data) {
    this.selectedMappe = data;
    this.mappeBezPopupVisible = true;
  }

  onPopupClose(event) {
    this.clear();
  }

  onPopupCloseOk(event) {
    this.clear();
    this.loadDocuments();
  }

  clear() {
    if (this.fileUploader) {
      this.fileUploader.instance.reset();
    }
    this.uploadFileName = '';
    this.isUploaded = 0;
    this.toUpload = 0;
    this.uploadFiles = [];
    this.uploadContext = null;
    this.selectedDokument = null;
    this.selectedMappe = null;
    this.uploadPopupVisible = false;
    this.editBezPopupVisible = false;
    this.mappeBezPopupVisible = false;
    this.showUploadModal = false;
    this.uploadWaitPopupVisible = false;
    this.isUploadCanceled = false;
  }

  private startLoading() {
    this.spinnerService.show();
    this.loading = true;
  }

  private stopLoading() {
    this.spinnerService.hide();
    this.loading = false;
  }

  getFileExtension1(filename) {
    return /[.]/.exec(filename) ? '.' + /[^.]+$/.exec(filename)[0] : undefined;
  }

  onDeleteFile(data) {
    const sub1 = this.modalService.confirm('Datei wirklich unwiderruflich löschen?').subscribe((result) => {
      if (result) {
        this.startLoading();
        this.ajaxService.post('api/Dokument/DeleteDocuments', { ids: [data.id] }).subscribe({
          next: (response) => {
            this.loadDocuments();
          },
          error: (e) => {
            this.stopLoading();
            throw e;
          },
        });
      }

      sub1.unsubscribe();
      sub1.remove(sub1);
    });
  }

  onDeleteFileMap(data) {
    const ids = data.items.map((x) => {
      return x.id;
    });

    const sub1 = this.modalService.confirm('Dateimappe wirklich unwiderruflich mit allen Dateien löschen?').subscribe((result) => {
      if (result) {
        this.startLoading();
        this.ajaxService.post('api/Dokument/DeleteDocuments', { ids: ids }).subscribe({
          next: (response) => {
            this.loadDocuments();
          },
          error: (e) => {
            this.stopLoading();
            throw e;
          },
        });
      }

      sub1.unsubscribe();
      sub1.remove(sub1);
    });
  }
}
